import { darken, getLuminance, lighten, parseToRgb } from 'polished'

const defaults = {
  emphasizeCoefficient: 0.16,
} as const

export function isLightOrDark(color: string) {
  const luminance = getLuminance(color)
  const threshold = 0.5

  return luminance >= threshold ? 'light' : 'dark'
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
export function emphasize(
  color: string,
  coefficient = defaults.emphasizeCoefficient
) {
  return isLightOrDark(color) === 'light'
    ? darken(coefficient, color)
    : lighten(coefficient, color)
}

export const colorWithOpacity = (color: string, opacity: number) => {
  const rgb = parseToRgb(color)

  return `rgba(${rgb.red},${rgb.green},${rgb.blue}, ${opacity})` as const
}
